import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { ExpiringContractsDirectServiceData, PastExpiringContractsDirectService } from "../../services/contractsKpi/expiringContractsDirect.service";
import { ContractDetail, ExpiringContractsDirectDetailServiceData, PastExpiringContractsDirectDetailService } from "../../services/contractsKpi/expiringContractsDirectDetail.service";
import { DateColumnDefinition, EmailColumnDefinition, NumberColumnDefinition, PhoneNumberColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";
import { ContractsDirectDetailData } from "./contractsDirectDetailData";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";

@Component({
    selector: 'past-expiring-contracts-direct-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class PastExpiringContractsDirectKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<PastExpiringContractsDirectService, ExpiringContractsDirectServiceData, ExpiringContractsDirectServiceData, PastExpiringContractsDirectDetailService, ExpiringContractsDirectDetailServiceData, ContractsDirectDetailData>
    implements OnDestroy {
    public getClassName() { return "PastExpiringContractsDirectKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: PastExpiringContractsDirectService, detailService: PastExpiringContractsDirectDetailService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: ExpiringContractsDirectServiceData): ExpiringContractsDirectServiceData {
        this.setWarn(data.consultant + data.office > 0);
        return data;
    }

    protected getDefaultSummaryData(): ExpiringContractsDirectServiceData {
        this.setWarn(false);
        let data = new ExpiringContractsDirectServiceData();
        data.consultant = 0;
        data.office = 0;
        data.updateTimestamp = new Date();
        return data;
    }

    protected extractUpdateTime(data: ExpiringContractsDirectServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: ExpiringContractsDirectDetailServiceData, args: any): ContractsDirectDetailData {

        let end = moment().subtract(1, 'day');
        let begin = moment(end).subtract(15, 'day');
        if (data.contracts) {
            if (args && args.filter && args.filter.consultant) {
                let columnDefinitions = [
                    new DateColumnDefinition("Fecha fin", (data) => moment(data).format("DD/MM/YYYY"), true),
                    new TextColumnDefinition("Cliente", null, true),
                    new TextColumnDefinition("Trabajador"),
                    new PhoneNumberColumnDefinition("Teléfono"),
                    new EmailColumnDefinition("Email"),
                    new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
                    new NumberColumnDefinition("Tp. Contrato"),
                    new TextColumnDefinition("Consultor", null, true),
                    new TextColumnDefinition("Unidad", null, true),
                    new TextColumnDefinition("Nombre interlocutor", null, true),
                    new PhoneNumberColumnDefinition("Teléfono interlocutor"),
                ];

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.contracts).find(x => x.userDocNumber == consultantNif) || { name: null }).name;
                        columnDefinitions[7].filterTerm = [consultantName];
                    }
                    if (args.filter.date) columnDefinitions[0].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
                }

                let tabledata2 = [];
                let tabledata = [];

                for (let contract of data.contracts) {
                    if (contract.userDocNumber.toUpperCase() == consultantNif) {
                        tabledata.push([
                            contract.endDate,
                            contract.clientFiscalName,
                            contract.workerName,
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.workContractId,
                            contract.userName,
                            contract.unitName,
                            contract.contactName,
                            contract.contactPhone,
                        ]);
                    }
                    else {
                        tabledata2.push([
                            contract.endDate,
                            contract.clientFiscalName,
                            contract.workerName,
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.workContractId,
                            contract.userName,
                            contract.unitName,
                            contract.contactName,
                            contract.contactPhone,
                        ]);
                    }
                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new ContractsDirectDetailData(columnDefinitions, arrayOrdenado);
            } else {
                let columnDefinitions = [
                    new TextColumnDefinition("Consultor", null, true),
                    new TextColumnDefinition("Unidad", null, true),
                    new DateColumnDefinition("Fecha fin", (data) => moment(data).format("DD/MM/YYYY"), true),
                    new TextColumnDefinition("Cliente", null, true),
                    new TextColumnDefinition("Trabajador"),
                    new PhoneNumberColumnDefinition("Teléfono"),
                    new EmailColumnDefinition("Email"),
                    new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
                    new NumberColumnDefinition("Tp. Contrato"),
                    new TextColumnDefinition("Nombre interlocutor", null, true),
                    new PhoneNumberColumnDefinition("Teléfono interlocutor"),
                ];

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.contracts).find(x => x.userDocNumber == consultantNif) || { name: null }).name;
                        columnDefinitions[0].filterTerm = [consultantName];
                    }
                    if (args.filter.date) columnDefinitions[2].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
                }

                let tabledata2 = [];
                let tabledata = [];

                for (let contract of data.contracts) {
                    if (contract.userDocNumber.toUpperCase() == consultantNif) {
                        tabledata.push([
                            contract.userName,
                            contract.unitName,
                            contract.endDate,
                            contract.clientFiscalName,
                            contract.workerName,
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.workContractId,
                            contract.contactName,
                            contract.contactPhone,
                        ]);
                    }
                    else {
                        tabledata2.push([
                            contract.userName,
                            contract.unitName,
                            contract.endDate,
                            contract.clientFiscalName,
                            contract.workerName,
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.workContractId,
                            contract.contactName,
                            contract.contactPhone,
                        ]);
                    }
                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new ContractsDirectDetailData(columnDefinitions, arrayOrdenado);
            }
        }
        else return this.getDefaultDetailData();
    }

    private extractConsultants(data: ContractDetail[]): { userDocNumber: string, name: string }[] {
        let userDocNumbers: { userDocNumber: string, name: string }[] = [];

        if (data) {
            data.forEach(x => {
                if (!userDocNumbers.find(y => x.userDocNumber.toUpperCase() == y.userDocNumber)) userDocNumbers.push({ userDocNumber: x.userDocNumber.toUpperCase(), name: x.userName });
            })
        }

        return userDocNumbers;
    }

    protected getDefaultDetailData(): ContractsDirectDetailData {
        let columnDefinitions = [
            new TextColumnDefinition("Consultor", null, true),
            new TextColumnDefinition("Unidad"),
            new DateColumnDefinition("Fecha fin", (data) => moment(data).format("DD/MM/YYYY")),
            new TextColumnDefinition("Cliente"),
            new TextColumnDefinition("Trabajador"),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
            new NumberColumnDefinition("Tp. Contrato"),
            new TextColumnDefinition("Nombre interlocutor", null, true),
            new PhoneNumberColumnDefinition("Teléfono interlocutor"),
        ];

        return new ContractsDirectDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }
}
